export enum EntryState {
    Live = 'live',
    Preview = 'preview',
}

export enum LogicalOperators {
    AND = '$and',
    OR = '$or',
    NOT = '$not',
}

export enum AttributeOperators {
    EQUAL_TO = '$eq',
    EQUAL_TO_CASE_INSENSITIVE = '$eqi',
    NOT_EQUAL_TO = '$ne',
    NOT_EQUAL_TO_CASE_INSENSITIVE = '$nei',
    INCLUDES_IN = '$in',
    NOT_INCLUDES_IN = '$notIn',
    LESS_THAN = '$lt',
    LESS_THAN_EQUAL_TO = '$lte',
    GREATER_THAN = '$gt',
    GREATER_THAN_EQUAL_TO = '$gte',
    BETWEEN = '$between',
    CONTAINS = '$contains',
    CONTAINSI = '$containsi',
    NOT_CONTAINS = '$notContains',
    STARTS_WITH = '$startsWith',
    STARTS_WITHI = '$startsWithi',
    ENDS_WITH = '$endsWith',
    ENDS_WITHI = '$endsWithi',
    IS_NULL = '$null',
    IS_NOT_NULL = '$notNull',
}

export enum SortBy {
    PUBLISHED_AT = 'publishedAt',
    CREATED_AT = 'createdAt',
    ID = 'id',
}

export enum Order {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}

export enum KeyType {
    TOPICS_URL = 'topics.url',
    URL = 'url',
    SLUG = 'slug',
    USERNAME = 'username',
    AUTHOR_ID = 'authorName.id',
    BRAND = 'brand',
    CATEGORY = 'category',
    PAGE_TAG_FILTER_1 = `${LogicalOperators.AND}.0.${LogicalOperators.OR}.0.pageTags`,
    PAGE_TAG_FILTER_2 = `${LogicalOperators.AND}.0.${LogicalOperators.OR}.1.pageTags`,
    PAGE_TAG_FILTER_3 = `${LogicalOperators.AND}.0.${LogicalOperators.OR}.2.pageTags`,
    PAGE_TAG_FILTER_4 = `${LogicalOperators.AND}.1.${LogicalOperators.OR}.0.pageTags`,
    PAGE_TAG_FILTER_5 = `${LogicalOperators.AND}.1.${LogicalOperators.OR}.1.pageTags`,
    PAGE_TAG_FILTER_6 = `${LogicalOperators.AND}.1.${LogicalOperators.OR}.2.pageTags`,
}

export enum ComponentTypes {
    NewsAdEmbedded = 'relation.news-ad-embedded',
    BlogAdEmbed = 'relation.blog-ad-embed',
    ReviewsAdEmbedded = 'relation.reviews-ad-embedded',
    RichTextCK = 'text-editor.rich-text-ck',
    BlogAdCollapsible = 'relation.blog-ad-collapsible',
    BlogAdTC = 'relation.blog-ad-tc',
    BlogAdSWC = 'relation.blog-ad-swc',
}

export enum Locale {
    English = 'en',
}
